module.exports = __webpack_public_path__ + "img/Schnurbart.09cdfe2d.svg";